import { Link } from "@tanstack/react-router";
import { useRef } from "react";

import { Image } from "@/components/Image/Image";
import { useInViewportOnce } from "@/hooks/useInViewportOnce";

type Props = {
  tripId: string;
  src: string;
  title: string;
  onViewed?: () => void;
  onClicked?: () => void;
};

export const TripBanner = ({
  tripId,
  src,
  title,
  onViewed,
  onClicked,
}: Props) => {
  const ref = useRef<HTMLAnchorElement>(null);

  useInViewportOnce(ref, {
    callback: onViewed,
  });

  return (
    <Link ref={ref} to="/trips/$tripId" params={{ tripId }} onClick={onClicked}>
      <Image src={src} alt={title} className="mx-auto w-full rounded-2xl" />
    </Link>
  );
};
